module.exports = __webpack_public_path__ + "img/minipack-active.6dd85bc3.svg";